import type React from 'react';

import { useI18n } from '@change-corgi/core-react/i18n';

import { usePsfSharePageData } from '#src/app/pages/psf/share/pageContext';
import { useTrackExperimentExposureOnMount } from '#src/app/shared/hooks/tracking';

import { PageBanner } from '../components/PageBanner';
import { PageBody } from '../components/PageBody';
import { PageFooter } from '../components/PageFooter';
import { PageState } from '../components/PageState';

import { useTrackPageView } from './hooks/useTrackPageView';

export const Layout: React.FC = () => {
	useTrackPageView();
	const {
		data: { experiments },
	} = usePsfSharePageData();
	// POC: testing GrowthBook & Amplitude experiment services in prod, no variant behavior
	useTrackExperimentExposureOnMount(experiments.pocGrowthbookPsfShareDummy);
	useTrackExperimentExposureOnMount(experiments.pocAmplitudePsfShareDummy);
	const { translate } = useI18n();

	return (
		<>
			{/* PageBanner on desktop only - on mobile it's inside parallax */}
			<div className="relative hidden md:block">
				<PageBanner />
			</div>

			<section
				aria-label={translate('corgi.psf.share.page_landmark')}
				// eslint-disable-next-line @change-ds/ds-no-arbitrary-spacing-classname
				className="bg-background-overlay min-h-screen w-full pb-16 md:pt-[50px]"
			>
				<PageState />
				<div className="mx-auto max-w-[610px]">
					<PageBody />
					<PageFooter />
				</div>
			</section>
		</>
	);
};
